import { handleFetch } from "../utils/fetch";
import config from "../components/App/config";

export const handleFetchAirlines = (conf: any) => {
  const { injectAirlines, fetchAircrafts, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "airlines.json"
    },
    {
      success: (json: any) =>
        handleFetchAirlinesSuccess({ injectAirlines, fetchAircrafts, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchAirlinesSuccess = (conf: any) => {
  const { injectAirlines, fetchAircrafts, json } = conf;
  injectAirlines(json);
  fetchAircrafts();
};

export const handleFetchAircrafts = (conf: any) => {
  const { injectAircrafts, fetchCountries, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "aircrafts.json"
    },
    {
      success: (json: any) =>
        handleFetchAircraftsSuccess({ injectAircrafts, fetchCountries, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchAircraftsSuccess = (conf: any) => {
  const { injectAircrafts, fetchCountries, json } = conf;
  injectAircrafts(json);
  fetchCountries();
};

export const handleFetchCountries = (conf: any) => {
  const { injectCountries, fetchAirports, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "countries.json"
    },
    {
      success: (json: any) =>
        handleFetchCountriesSuccess({ injectCountries, fetchAirports, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchCountriesSuccess = (conf: any) => {
  const { injectCountries, fetchAirports, json } = conf;
  injectCountries(json);
  fetchAirports();
};

export const handleFetchAirports = (conf: any) => {
  const { injectAirports, fetchPlaces, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "airports.json"
    },
    {
      success: (json: any) =>
        handleFetchAirportsSuccess({ injectAirports, fetchPlaces, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchAirportsSuccess = (conf: any) => {
  const { injectAirports, fetchPlaces, json } = conf;
  injectAirports(json);
  fetchPlaces();
};

export const handleFetchPlaces = (conf: any) => {
  const { injectPlaces, fetchTrips, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "places.json"
    },
    {
      success: (json: any) =>
        handleFetchPlacesSuccess({ injectPlaces, fetchTrips, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchPlacesSuccess = (conf: any) => {
  const { injectPlaces, fetchTrips, json } = conf;
  injectPlaces(json);
  fetchTrips();
};

export const handleFetchTrips = (conf: any) => {
  const { injectTrips, handleFetchFail } = conf;
  const { fetchUrl } = config;
  handleFetch(
    {
      url: fetchUrl + "trips.json"
    },
    {
      success: (json: any) => handleFetchTripsSuccess({ injectTrips, json }),
      error: handleFetchFail
    }
  );
};

const handleFetchTripsSuccess = (conf: any) => {
  const { injectTrips, json } = conf;
  injectTrips(json);
};
